import { render, staticRenderFns } from "./PermissionAdd.vue?vue&type=template&id=799e1e4a&"
import script from "./PermissionAdd.vue?vue&type=script&lang=js&"
export * from "./PermissionAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports